import { render, staticRenderFns } from "./AddMemberNotesModal.vue?vue&type=template&id=58670a6f&scoped=true&"
import script from "./AddMemberNotesModal.vue?vue&type=script&lang=js&"
export * from "./AddMemberNotesModal.vue?vue&type=script&lang=js&"
import style0 from "./AddMemberNotesModal.vue?vue&type=style&index=0&id=58670a6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58670a6f",
  null
  
)

export default component.exports